export { getUserInfoServerAction } from 'next-flight-server-reference-proxy-loader?id=7f009dc938bbebe082be870681cb75cb2855c483ec&name=getUserInfoServerAction!'